import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
  selector: 'app-first-payment-option',
  templateUrl: './first-payment-option.component.html',
  styleUrls: ['./first-payment-option.component.css']
})
export class FirstPaymentOptionComponent implements OnInit {
  is_loader: boolean;

  constructor(private sharedService: SharedService, private router: Router, private localStorageService: LocalStorageService) { 
  	// this.sharedService.setHeaderTitle('congrats');

	var dataLayerEvent = 'enroll - payment method';
    (window as any).dataLayer.push({'event': dataLayerEvent});
  	this.is_loader = true;
  	this.sharedService.setLoader('congrats', true);
  	if (this.localStorageService.get('token') != null) {
  		this.sharedService.verifyToken({'token' : this.localStorageService.get('token')})
	  		.then(res=>{
	  			this.is_loader = false;
	  			this.sharedService.setLoader('congrats', false);
	  			if (res.status == 'success'  && res.isTerminated == false) {
	  				const person = res.results[0]['personal'];
	  				this.sharedService.setHeaderUserLoggedIn('congrats', true, person[0]);
	  			} else {
	  				this.localStorageService.remove('token');
                	this.router.navigate(['./enroll']);
	  			}
			});
  	} else {
  		this.router.navigate(['./enroll']);
  	}
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/customer-enroll/first-payment-option/first-payment-option.component.ts